module.exports = __webpack_public_path__ + "img/twitter_logo.dd90206d.svg";